import React,{useState, useEffect} from "react";
import {useParams} from 'react-router-dom';
import { COMPOSE_MESSAGE_FOR_CAMPAIGN_LINK } from '../../constants/constants';
import { notifyError,notifyErrorInBottom,notifySuccess } from "../../helper";
import { confirmAlert } from "react-confirm-alert"; // Import the library
import Header from "../Header";
import Footer from "../Footer";
import Sidebar from "../Sidebar";
import Tabs from "./Tabs";
import BlockLoader from "../../components/BlockLoader";
import client from "../../api";
import "react-confirm-alert/src/react-confirm-alert.css";
import RecipientModelWindow from "./models/RecipientModelWindow";

const AddRecipientsInCampaign = () => {
    const api = client();
    const {campaignID} = useParams('');
    const [displayModelWindow,setDisplayModelWindow] = useState(false);
    const [blockLoader, setBlockLoader] = useState(true);
    const [recipientsData, setRecipientsData] = useState({'campaignID':campaignID,'contactListName':'','listId':''});
    const [listToBeLinked, setListToBeLinked] = useState('');
    const [campaignPreview, setCampaignPreview] = useState({});
    
    const [loading,setLoading] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [deleteLoader,setDeleteLoader] = useState('');
    const [contactLists,setContactLists] = useState();
    const [primaryHeads, setPrimaryHeads] = useState([]);
    const [secondaryHeads, setSecondaryHeads] = useState([]);
    const [error,setError] = useState({});

    const removeError = (e) => {
        setError({ ...error, [e.target.name]: "" });
    }

    const fieldBlur = (e) => {
        //const fieldError = validatorObject.validateFields(e.target.value, e.target.name)
        //if (Object.keys(fieldError).length) setError({ ...error, ...fieldError });        
    }
    const validateAllFields = () => {
        return (recipientsData.listId !== '' && recipientsData.campaignID !== '');

    }
    
    const addContactListInCampaign = async (type) => {
        setLoading(true);
        try{            
            if(validateAllFields()){
                setBlockLoader(true);
                const response = await api.post('/v1/campaign/contactsList/update',{   
                    "campaign_id":recipientsData.campaignID, 
                    "list_id":recipientsData.listId,
                    "current_tab":"compose",
                    "completed_tabs":["start", "add-recipients"]                 
                });
                
                if(response.status === 200 || response.status === 201){
                    notifySuccess('Recipients List linked with Campaign');
                    setTimeout(()=>{
                        if(type === 'dropdown'){
                            window.location.reload();
                        }
                    },1000);
                    setLoading(false);
                }
            } else {
                setLoading(false);
                setBlockLoader(false);
                notifyError("Campaign Id or contact List Id is missing");
            }
            
        } catch(error){
            setLoading(false);
            setBlockLoader(false);

            if(error.status === 409){
                setPrimaryHeads(error.response.data.original_parameter);
                setSecondaryHeads(error.response.data.current_parameter);
                setDisplayModelWindow(true);
            }
            
            console.log('error.message',error);
            if(error.status === 400) notifyError("Bad Request. Either campaign doesn't exists or contact list already exists in campaign"); 
        }
    }
    const attachContactListInCampaign = async (campaignId,listId) => {
        try{
            setListToBeLinked(listId);
            const response = await api.post('/v1/campaign/contactsList/update',{   
                "campaign_id":campaignId, 
                "list_id":listId,
                "current_tab":"compose",
                "completed_tabs":["start", "add-recipients", "compose", "preview", "options"]                 
            });
            
            if(response.status === 200 || response.status === 201){
                notifySuccess('Recipients List linked with Campaign');
                setTimeout(()=>{
                    window.location.href = COMPOSE_MESSAGE_FOR_CAMPAIGN_LINK.replace(':campaignID',campaignId);
                },1000);
            }
        } catch(error){
            if(error.status === 409){
                setPrimaryHeads(error.response.data.original_parameter);
                setSecondaryHeads(error.response.data.current_parameter);
                setDisplayModelWindow(true);
            }
            console.log('error.message',error);
            if(error.status === 400) notifyError('Bad Request. Not able to attach Contact List in campaign. Please try again');

        }
    }
    const handleFileUpload = async () => {
        // if(recipientsData.contactListName === ''){
        //     notifyErrorInBottom('Please Enter Contact List Name');
        //     return;
        // }
        const file = document.getElementById('csv-upload');
        if (file) {
            setUploading(true);
            // Create a FormData object
            const formData = new FormData();
            formData.append("contactFile", file.files[0]);
            formData.append("name", recipientsData.contactListName ? recipientsData.contactListName : getCleanFileName(file.value.split("\\").pop()));
            
            try {
                // Replace with your API endpoint
                const response = await api.post("/v1/contactList/create",formData,{ headers:{ 'Action':'upload' }});
                if (response.status === 200 || response.status === 201) {
                  notifySuccess("File uploaded successfully!");
                  setUploading(false);
                  attachContactListInCampaign(campaignID,response.data.data.id);  
                } 
              } catch (error) {
                setUploading(false);
                if(error.status === 400) notifyError('Bad Request. Not able to create a Contact List. Please try again');
              }
        } else {
            notifyErrorInBottom('Please choose a csv file to upload');
        }        
    }

    const getCleanFileName = (fileName) => {
        let cleanedFileName = fileName.replace(/[^a-zA-Z0-9]+/g, ' ');
        cleanedFileName = cleanedFileName.replace(/csv$/, '');
        cleanedFileName = cleanedFileName.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
        return cleanedFileName;
      }

    const handleInputChange = (e) => {
        setRecipientsData({...recipientsData, [e.target.name]:e.target.value});
    }

    const handleContactListSelect = (obj) => {
        setListToBeLinked(obj.listId);
        setRecipientsData({...recipientsData,...obj});
    }
    const handleContactListDelete = async (listId) => {
        setDeleteLoader(listId);
        try{
            const resposne = await api.post('/v1/campaign/contactsList/delete',{
                campaign_id:campaignID, 
                list_id:listId
            });

            if(resposne.status === 200 || resposne.status === 201){
                notifySuccess('contact list deleted successfully.');
                setDeleteLoader('');
                setTimeout(()=>{
                    window.location.reload();
                },2000);
            }

        } catch (error){
            console.log('error.message',error);
            if(error.status === 400) notifyError('Bad Request. Not able to delete a contact List');
        }
        setTimeout(()=>{
            setDeleteLoader('');
        },4000);
    }

    const moveToNextStep = () => {
        if((campaignPreview?.list_details).length){
            window.location.href = COMPOSE_MESSAGE_FOR_CAMPAIGN_LINK.replace(':campaignID',recipientsData.campaignID);
        } else {
            notifyError('Please add a contact List in this campaign');
        }
    }

    useEffect(()=>{
        if(recipientsData.listId !== '')
            addContactListInCampaign('dropdown');
    },[recipientsData]);

    useEffect(()=>{
        const getContactLists = async () =>{
            try{
                const response = await api.post('/v1/campaign/contactsList/all');
                if(response.status === 201 || response.status === 200){                
                    setContactLists(response.data.contacts_list);
                }
            } catch(error){
                console.log('error.message',error);
                if(error.status === 400) notifyError('Bad Request. Not able to fetch Mail Accounts. Please try again'); 
            }
        }
        if(contactLists === undefined){
            getContactLists();
        }
        
    });

    useEffect(()=>{
        const getCampaignPreview = async () => {
            try{
                setBlockLoader(true);
                const response = await api.post('/v1/campaign/preview',{ campaign_id:campaignID });
                if(response.status === 200 ||response.status === 201 ){
                    setCampaignPreview(response.data.campaignPreview);
                    setBlockLoader(false);
                }
            } catch(error){
                console.log('error.message',error);
                setBlockLoader(false);
                if(error.status === 400) notifyError('Bad Request. Not able to fetch Campaign Overview');
            }
        }
        getCampaignPreview();
    },[]);

    useEffect(()=>{
        //Reset RecipientData if ModelWindow is cancelled
        if(!displayModelWindow){
            setListToBeLinked('');
            setRecipientsData({'campaignID':campaignID,'contactListName':'','listId':''});
        }        
    },[displayModelWindow]);

    return(<>
        <Header/>
        <div className="main-page">
            <Sidebar/>
           <div className="campaign-create-steps">
                <div className="top-section">
                    <h1>Add Campaign </h1>                
                </div>
                <div className="steps-wrap">
                    <Tabs currentTab="add-recipients" completedTabs={campaignPreview.completed_tab} />

                    {blockLoader ? <div className="recipient-loader"><BlockLoader /></div> : ((Object.keys(campaignPreview).length && campaignPreview?.list_details.length) ? <div className="added-contact-list-wrap">
                            <h3>Added recipients to your campaign</h3>
                            <div className="contact-list-block-wrap">
                             {(campaignPreview?.list_details).map((contact,i)=>(
                                <div className="contact-list-block" key={i}>
                                    <div className="list-details">
                                        <span className="list-name">{contact.name}</span>
                                        <span className="contact-count">{contact.contacts_count} recipients</span>
                                    </div>
                                    <div className="list-action">
                                        <span className="delete-icon" onClick={()=>{                                            
                                            confirmAlert({
                                                title: "Delete Contact List...!",
                                                message: "Are you sure you want to delete the Contact List from this Campaign?",
                                                buttons: [
                                                    { label: "Delete", onClick: () => {handleContactListDelete(contact._id)} },
                                                    { label: "Cancel", onClick: () => {console.log('Delete action canceled..!')}}
                                                ]
                                            })
                                        }}>
                                            {deleteLoader === contact._id ? <div className="loader"></div> : <i className='bx bx-trash'></i>}                                            
                                        </span>
                                    </div>
                                </div>))}
                            </div>
                            <button className="next-btn import-btn" onClick={()=>{moveToNextStep()}}>Next</button>
                        </div>:'')}
                    <div className="recipient-step">
                        <h3>Drop in your lists of recipients</h3>
                        <form className="step-forms" onSubmit={(e)=>{e.preventDefault()}} method="POST">
                            <div className="option-1">
                                <div className="field-wrap">
                                    <label className="label-xs"> Contact List Name</label>
                                    <input
                                        name='contactListName' 
                                        type="text" 
                                        placeholder="Contact List Name"
                                        value={recipientsData.contactListName}
                                        onFocus={(e)=>{}}

                                        onChange={handleInputChange}
                                        />
                                </div>
                                <div className="field-wrap upload-block">
                                    <label className="label-xs"> Choose a CSV file here {/*<span> (or choose one)</span>*/}</label>
                                    <input type="file" accept=".csv" name="uploadcsv" id="csv-upload" />
                                </div>
                                <div className="field-wrap upload-btn">
                                    <button className="primary-btn" onClick={(e)=>{handleFileUpload()}}>Upload</button>
                                </div>
                                {uploading ? <div className="progress-bar">
                                    <div className="progress-bar-value"></div>
                                </div>:''}
                            </div>
                            {/* <div className="or">OR</div>
                            <div className="option-2">
                            <div className="field-wrap">
                                <label className="label-xs"> Type email addresses manually</label>
                                <textarea className="textarea"></textarea>                
                            </div>
                            </div> */}
                            <div className="or">OR</div>
                            <div className="option-3">
                                <div className="field-wrap">
                                    <label className="label-xs">Select an existing list</label>
                                    <select className="selectbox" name="listId" onChange={(e)=>{
                                        handleContactListSelect({[e.target.name]:e.target.value});
                                        }}>
                                        <option value="">Select Contact List</option>
                                        {contactLists && contactLists.map((value,index)=>(<option key={index} value={value.id}>{value.name}</option>))}
                                    </select>
                                </div>
                            </div>
                        </form>
                        
                    </div>                    
                </div>
            </div>            
        </div>
        {displayModelWindow && <RecipientModelWindow 
            primaryHeads = {primaryHeads} 
            secondaryHeads = {secondaryHeads}
            displayModelWindow = {displayModelWindow}
            setDisplayModelWindow = {setDisplayModelWindow}
            listToBeLinked = {listToBeLinked}
            />}
        <Footer/>
    </>);
}

export default AddRecipientsInCampaign;


